import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

import Iconify from '@/components/Iconify'
import useRealNode from '@/hooks/useRealNode'

import CompleteFacebookData from '../complete-facebook-form'
import VerificationSMS from '../verification-sms'
import CloseOtherSessions from '../close-other-sessions'
import WelcomeSuccess from '../welcome-success'
import NotificationBar from './notification-bar'
import AuthModalBackdrop from './auth-modal-backdrop'

import useAuth from '../../hooks/use-auth'
import { AUTH_STEPS as STATUS } from '../../constants/auth-steps'
import { MODAL_HOLD_STEPS } from '../../constants/config'
import {
  ModalBar,
  ModalCloseButton,
  ModalContent,
  ModalInner,
  ModalOverlay,
  ModalScrollCenter,
  ModalScrollLayer,
} from './auth-modal.styled'
import { AuthAutofillStyles } from './auth-autofill-styles'

const PORTAL_ID = 'auth-modal-portal'

const MODAL_ONLY_STEPS = [
  STATUS.COMPLETE_FACEBOOK_DATA,
  STATUS.SMS_CONFIRMATION,
  STATUS.CLOSE_ANOTHER_SESSIONS,
  STATUS.WELCOME_SUCCESS,
]

const stopOverlayInteraction = (event) => {
  event.stopPropagation()
}

export default function AuthModal () {
  const { loginStatus, closeModal } = useAuth()
  const portalNode = useRealNode(PORTAL_ID)
  const canClose = loginStatus && !MODAL_HOLD_STEPS.includes(loginStatus)
  const isModalOpen = loginStatus && MODAL_ONLY_STEPS.includes(loginStatus)

  useEffect(() => {
    if (!isModalOpen) return undefined

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const el = document.querySelector('.fade[tabindex="-1"]')
    if (el) {
      el.removeAttribute('tabindex')
    }

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [isModalOpen])

  function getActiveStep () {
    switch (loginStatus) {
      case STATUS.COMPLETE_FACEBOOK_DATA: return <CompleteFacebookData />
      case STATUS.SMS_CONFIRMATION: return <VerificationSMS />
      case STATUS.CLOSE_ANOTHER_SESSIONS: return <CloseOtherSessions />
      case STATUS.WELCOME_SUCCESS: return <WelcomeSuccess />
      default: return null
    }
  }

  if (!isModalOpen || !portalNode) return null

  return ReactDOM.createPortal(
    <>
      <AuthAutofillStyles />
      <ModalOverlay tabIndex={-1} onMouseDown={stopOverlayInteraction}>
        <AuthModalBackdrop />
        <ModalScrollLayer onMouseDown={stopOverlayInteraction}>
          <ModalScrollCenter>
            <ModalContent onMouseDown={stopOverlayInteraction}>
            <ModalBar>
              {canClose && (
                <ModalCloseButton type='button' onClick={closeModal} aria-label='Cerrar'>
                  <Iconify icon='ic:baseline-close' />
                </ModalCloseButton>
              )}
            </ModalBar>
            <ModalInner>
              <NotificationBar />
              {getActiveStep()}
            </ModalInner>
            </ModalContent>
          </ModalScrollCenter>
        </ModalScrollLayer>
      </ModalOverlay>
    </>,
    portalNode
  )
}
